import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdAutorenew } from "react-icons/md";

import PropTypes from "prop-types";

import DataTable from "../Shared/DataTable";
import { Spinner } from "../Shared";
import { message } from "../../_constants";

export class CurrenciesList extends Component {
  render() {
    const columns = [
      /* {
        Header: "Id",
        accessor: "id"
      }, */
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Alpha Code",
        accessor: "alphaCode"
      },
      {
        Header: "Numeric Code",
        accessor: "numericCode"
      }
    ];

    const { match, fetching, data, loadData, error } = this.props;

    return (
      <div>
        <Row>
          <Col sm="6">
            <h5 className="item-count">
              {data && data.count} Result(s) Found
            </h5>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <Button
                disabled={fetching}
                onClick={loadData}
                className="btn btn-primary btn-outline"
              >
                {fetching ? (
                  <Spinner />
                ) : (
                  <span>
                    <MdAutorenew size={20} /> Refresh
                  </span>
                )}
              </Button>{" "}
              <Link to={`${match.url}/add`} className="btn btn-primary">
                Add Currency
              </Link>
            </div>
          </Col>
        </Row>
        <hr />
        {error && <Alert color="danger">{message.OUTDATED_DATA}</Alert>}
        <DataTable
          columns={columns}
          loading={fetching}
          urlParams={match}
          data={data && data.modelList ? data.modelList : []}
          defaultPageSize={10}
          cannotEdit={true}
        />
      </div>
    );
  }
}

CurrenciesList.proptypes = {
  match: PropTypes.object.isRequired,
  data: PropTypes.object,
  loadData: PropTypes.func,
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  error: PropTypes.object
};

export default CurrenciesList;
